import { ChangeDetectionStrategy, Component, HostBinding, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { DisplayValueDescriptor, GalaxyDisplayValuePipe } from '@vendasta/galaxy/pipes';

// The direction the caret will face
export enum CHANGE_DIRECTION {
  NO_CHANGE,
  UPWARD_CHANGE,
  DOWNWARD_CHANGE,
}

// The color of the change
export enum CHANGE_TYPE {
  NO_CHANGE,
  POSITIVE_CHANGE,
  NEGATIVE_CHANGE,
}

export interface NumberWithChangeConfig {
  currentPeriod: DisplayValueDescriptor;
  previousPeriod?: DisplayValueDescriptor;
  previousPeriodChangeDirection?: CHANGE_DIRECTION;
  previousPeriodChangeType?: CHANGE_TYPE;
}

@Component({
  selector: 'glxy-number-with-change',
  imports: [CommonModule, MatIconModule, GalaxyDisplayValuePipe],
  templateUrl: './number-with-change.component.html',
  styleUrls: ['./number-with-change.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NumberWithChangeComponent {
  @HostBinding('class') class = 'glxy-number-with-change';

  @Input() changeInfo!: NumberWithChangeConfig;

  changeType = CHANGE_TYPE;
  changeDirection = CHANGE_DIRECTION;
}
